module.exports = __webpack_public_path__ + "static/media/roi.3b9a251e.svg";